import { Slider as SliderAntd } from 'antd'
import css from './Slider.module.scss'

type Props = {
  max?: number
  min?: number
  step?: null | number
  value: number
  onChange(value: number): void
}

export const Slider = (props: Props) => {
  const { min, max, step, value, onChange } = props

  return <SliderAntd className={css.slider} value={value} onChange={onChange}
    min={min} max={max} step={step} tooltip={{ open: false }} />
}
